interface Props {
  activeColor: string;
}
const CalendarIcon = (props: Props) => {
  const activeColor = props.activeColor ? props.activeColor : "#0f1560";
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10"
        y="12"
        width="28"
        height="24"
        rx="4"
        stroke="#0f1560"
        strokeWidth="2"
      />

      <line x1="10" y1="18" x2="38" y2="18" stroke="#0f1560" strokeWidth="2" />

      <line
        x1="16"
        y1="10"
        x2="16"
        y2="16"
        stroke="#0f1560"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="32"
        y1="10"
        x2="32"
        y2="16"
        stroke="#0f1560"
        strokeWidth="2"
        strokeLinecap="round"
      />

      <circle cx="18" cy="24" r="1.5" fill="#0f1560" />
      <circle cx="24" cy="24" r="1.5" fill="#0f1560" />
      <circle cx="30" cy="24" r="1.5" fill="#0f1560" />
      <circle cx="18" cy="29" r="1.5" fill="#0f1560" />
      <circle cx="24" cy="29" r="1.5" fill="#0f1560" />
      <circle cx="30" cy="29" r="1.5" fill="#0f1560" />
    </svg>
  );
};

export default CalendarIcon;
